import {
  ApiBlueprint,
  configApiRef,
  createApiFactory,
  createApiRef,
  createFrontendModule,
  discoveryApiRef,
  oauthRequestApiRef,
} from "@backstage/frontend-plugin-api";
import {
  ProfileInfoApi,
  BackstageIdentityApi,
  SessionApi,
  ApiRef,
} from "@backstage/core-plugin-api";
import { OAuth2 } from "@backstage/core-app-api";
import { SignInPageBlueprint } from "@backstage/plugin-app-react";
import { SignInPage } from "@backstage/core-components";

export const oidcAuthApiRef: ApiRef<
  ProfileInfoApi & BackstageIdentityApi & SessionApi
> = createApiRef({ id: "core.auth.oidc" });

const oidcAuthApi = ApiBlueprint.make({
  name: "oidc-auth",
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: oidcAuthApiRef,
        deps: {
          configApi: configApiRef,
          discoveryApi: discoveryApiRef,
          oauthRequestApi: oauthRequestApiRef,
        },
        factory: ({ configApi, discoveryApi, oauthRequestApi }) =>
          OAuth2.create({
            configApi,
            discoveryApi,
            oauthRequestApi,
            environment:
              configApi.getOptionalString("auth.environment") ?? "production",
            provider: {
              id: "oidc",
              title: "Keycloak",
              icon: () => null,
            },
            defaultScopes: ["openid", "profile", "email"],
          }),
      }),
    ),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => (
      <SignInPage
        {...props}
        providers={[
          "guest",
          {
            id: "oidc-auth-provider",
            title: "Keycloak",
            message: "Sign in with Keycloak",
            apiRef: oidcAuthApiRef,
          },
        ]}
      />
    ),
  },
});

export const authModule = createFrontendModule({
  pluginId: "app",
  extensions: [oidcAuthApi, signInPage],
});
